var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('h2',{ref:"headerTitle",staticClass:"do-resize"},[_vm._v("\n        Open tickets\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }